/**
 * The URL contract of the docs search: which path answers a search, and under
 * which query parameter.
 *
 * A leaf module with no imports, because it has two consumers that must never
 * disagree and that otherwise have no business importing each other:
 *
 *  - {@link ../pages/docs/DocsSearch} reads the parameter to seed its input, so
 *    `/docs?q=webhooks` lands on results.
 *  - `lib/seo/page-meta.ts` DECLARES that same URL to the outside world as a
 *    schema.org `SearchAction` on the site's `WebSite` node.
 *
 * If the two drift, the site publishes a machine-readable capability that does
 * not work — which is the exact failure this product exists to prevent for its
 * customers, committed on its own website (widget-discovery audit §14.2). The
 * constant is what makes the drift impossible rather than merely unlikely; a
 * test can only ever restate a literal.
 *
 * Kept free of the docs registry on purpose: `page-meta` ships in the marketing
 * entry chunk, which carries a test-enforced 140 KB budget (ADR-0194), and
 * importing `search-docs.ts` for one string would drag `docs-nav` in with it.
 */

/** Query parameter the docs search reads and the site declares. */
export const DOCS_SEARCH_QUERY_PARAM = 'q';

/**
 * English-relative path that answers a docs search. Localized per-locale by
 * `localizedPath` at both consumers — it is a real published route in
 * `features/seo/content/site-routes.ts`, which the declaration's test asserts.
 */
export const DOCS_SEARCH_PATH = '/docs';
